// import axios from "axios";

// const API_URL = process.env.REACT_APP_API_URL;

// const getAuthHeaders = () => {
//   const userId = localStorage.getItem("user_id");

//   return {
//     "Content-Type": "application/json",
//     ...(userId ? { "X-User-Id": userId } : {}),
//   };
// };

// /**
//  * Get discrepancy status for one specific image.
//  */
// export const getMediaDiscrepancy = async ({
//   jobId,
//   sourceType,
//   sourceId,
//   mediaIndex,
//   mediaUrl,
// }) => {
//   const response = await axios.get(
//     `${API_URL}/api/media-discrepancy`,
//     {
//       params: {
//         job_id: jobId,
//         source_type: sourceType,
//         source_id: sourceId,
//         media_index: mediaIndex,
//         media_url: mediaUrl,
//       },
//       headers: getAuthHeaders(),
//     }
//   );

//   return response.data;
// };

// /**
//  * Create/update discrepancy for one specific image.
//  */
// export const updateMediaDiscrepancy = async ({
//   jobId,
//   sourceType,
//   sourceId,
//   mediaIndex,
//   mediaUrl,
//   discrepancy,
//   discrepancyReason = null,
// }) => {
//   const response = await axios.patch(
//     `${API_URL}/api/media-discrepancy`,
//     {
//       job_id: jobId,
//       source_type: sourceType,
//       source_id: sourceId,
//       media_index: mediaIndex,
//       media_url: mediaUrl,
//       discrepancy,
//       discrepancy_reason: discrepancyReason,
//     },
//     {
//       headers: getAuthHeaders(),
//     }
//   );

//   return response.data;
// };

import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => {
  const userId = localStorage.getItem("user_id");

  return {
    "Content-Type": "application/json",
    ...(userId ? { "X-User-Id": userId } : {}),
  };
};

/**
 * Get discrepancy status for one specific image.
 */
export const getMediaDiscrepancy = async ({
  jobId,
  sourceType,
  sourceId,
  mediaIndex,
  mediaUrl,
}) => {
  const response = await axios.get(
    `${API_URL}/api/media-discrepancy`,
    {
      params: {
        job_id: jobId,
        source_type: sourceType,
        source_id: sourceId,
        media_index: mediaIndex,
        media_url: mediaUrl,
      },
      headers: getAuthHeaders(),
    }
  );

  return response.data;
};

/**
 * Create/update discrepancy for one specific image.
 */
export const updateMediaDiscrepancy = async ({
  jobId,
  sourceType,
  sourceId,
  mediaIndex,
  mediaUrl,
  discrepancy,
  discrepancyReason = null,
}) => {
  const response = await axios.patch(
    `${API_URL}/api/media-discrepancy`,
    {
      job_id: jobId,
      source_type: sourceType,
      source_id: sourceId,
      media_index: mediaIndex,
      media_url: mediaUrl,
      discrepancy,
      discrepancy_reason: discrepancyReason,
    },
    {
      headers: getAuthHeaders(),
    }
  );

  return response.data;
};

/**
 * Get ALL discrepancy-marked media for one job.
 *
 * This is used by Job Detail page so that it can
 * display the same discrepancy markers that were
 * marked from Job List page.
 */
export const getJobMediaDiscrepancies = async (jobId) => {
  const response = await axios.get(
    `${API_URL}/api/media-discrepancy/job/${jobId}`,
    {
      headers: getAuthHeaders(),
    }
  );

  return response.data;
};